import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { ModalButtonCancel, LabelBranch, LabelCommercialLine, PlaceHolderOption } from '../../constant';
import { Form, Label, ModalBody, Row, Input, FormFeedback, Col, ModalFooter, Button, FormGroup } from 'reactstrap';
import '../../assets/css/toggleSwitch.css';
//import '../../hooks/componentMultiSelect/MultiSelectDemo.css'
import '../../views/configuraciones/usersRoles/MultiSelect.css'

export const FormRates = (props) => {
    const {
        branches, commercialLines, typeRate, toggle, loading, handleInputChange, validacionesRates, methodAction, name,
        abbreviation, id_commercial_line, id_branch, id_type_rate, default_rate, toggleDivCommercialLine, viewDivBranches,
        button, changeCheckbox, branchDefault, isMultiSelectOpen, selectedBranch,
        hasDefaultRate,
        isDelete, valueCode, setValueCode, confirmationUpdate, validCode

    } = props;
    console.log("🚀 ~ FormRates ~ selectedBranch:", selectedBranch)
    console.log("🚀 ~ FormRates ~ hasDefaultRate:", hasDefaultRate)
    const {
        name_valid, abbreviation_valid,
        id_commercial_line_valid,
        id_branch_valid,
        id_type_rate_valid
    } = validacionesRates;

    // methodAction
    return (
        <>

            {
                !isDelete && <>
                <div className='form-section'>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="col-form-label">Nombre <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                <Input
                                    className="form-control form-control-sm input-air-primary"
                                    type="text"
                                    name="name"
                                    value={name}
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    invalid={name_valid}
                                />
                                <FormFeedback>Nombre invalido</FormFeedback>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="col-form-label">Abreviatura <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                <Input
                                    className="form-control form-control-sm input-air-primary"
                                    type="text"
                                    name="abbreviation"
                                    value={abbreviation}
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    invalid={abbreviation_valid}
                                />
                                <FormFeedback>Debes completar este campo</FormFeedback>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="col-form-label">{LabelCommercialLine}  <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                <Input
                                    className="form-control form-control-sm input-air-primary"
                                    type="select"
                                    name="id_commercial_line"
                                    value={id_commercial_line}
                                    onChange={handleInputChange}
                                    invalid={id_commercial_line_valid}>
                                    <option value={0}>{PlaceHolderOption}</option>
                                    {
                                        commercialLines.length >= 1 && commercialLines.map((obj, key) => {
                                            return (
                                                <option key={key} value={obj.id_commercial_line}>{obj.long_name}</option>
                                            )
                                        })
                                    }
                                </Input>
                                <FormFeedback>Selecciona un elemento de la lista</FormFeedback>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12" className='pb-2'  >
                            {
                                hasDefaultRate && <div
                                    style={{
                                        color: "#856404",
                                        fontSize: "0.78rem",
                                        marginTop: "6px",
                                        fontWeight: "500",
                                        backgroundColor: "#fff3cd",
                                        padding: "4px 10px",
                                        borderRadius: "6px",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        border: "1px solid #ffeeba",
                                    }}
                                >
                                    <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                    {"Un tarifario ya se encuentra  predefinido." ?? "---"}
                                </div>
                            }

                        </Col>
                        <Col md="12" style={{ display: 'flex', alignItems: 'center' }}>

                            <Label className="col-form-label f-w-600">Tarifario, predefinido para la razón social &nbsp;&nbsp;&nbsp;</Label>
                            <Label className="switch">
                                <Input
                                    type="checkbox"
                                    name="default_rate"
                                    onChange={toggleDivCommercialLine}
                                    checked={default_rate}
                                    disabled={hasDefaultRate && !default_rate}
                                />
                                <span className="slider round"></span>
                            </Label>

                        </Col>
                    </Row>
                    <br />
                    <br />
                    <Row className={viewDivBranches ? "d-none" : ""}>
                        <Col md="12">
                            <FormGroup>
                                <Label className=" labelFilter">{"Selecciona las sucursales a las que se aplicará este tarifario"} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
                                <MultiSelect
                                    className="basic-multi-select input-air-primary form-control-sm "
                                    value={selectedBranch}
                                    options={branchDefault}
                                    onChange={(e) => changeCheckbox(e.value)}
                                    optionLabel="name"
                                    placeholder={"Selecciona una Opción"}
                                    maxSelectedLabels={3}
                                    selectedItemsLabel="Secciones Agregadas"
                                    filter
                                    appendTo={document.body}


                                />
                            </FormGroup>
                        </Col>
                        <br />
                        <br />
                        {/* <Col md="12">
                    <FormGroup>
                        <Label className="col-form-label">Tipo de tarifario</Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            type="select"
                            name="id_type_rate"
                            value={id_type_rate}
                            onChange={handleInputChange}
                            invalid={id_type_rate_valid}>
                            <option value={0}>{PlaceHolderOption}</option>
                            {
                                typeRate.length >= 1 && typeRate.map((obj, key) => {
                                    return (
                                        <option key={key} value={obj.id_type_rate}>{obj.name}</option>
                                    )
                                })
                            }
                        </Input>
                        <FormFeedback>Selecciona un elemento de la lista</FormFeedback>
                    </FormGroup>
                </Col> */}
                    </Row>
                </div>

                </>
            }
            {
                isDelete &&
                <Col sm="12" className='p-l-0 p-r-0'>
                    <div
                        style={{
                            color: "#856404",
                            fontSize: "0.78rem",
                            marginTop: "6px",
                            fontWeight: "500",
                            backgroundColor: "#fff3cd",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                            border: "1px solid #ffeeba",
                            lineHeight: "1.4",
                        }}
                    >
                        <span style={{ marginRight: "6px", whiteSpace: "nowrap" }}>
                            <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                        </span>
                        Para aplicar el cambio en el tarifario, escriba la palabra <b>CONFIRMAR</b> y haga clic en el botón ACTUALIZAR.
                    </div>
                    <br />
                    <input
                        type="text"
                        className="input-line"
                        value={valueCode}
                        onChange={(e) => setValueCode(e.target.value)}
                        placeholder="Ingrese CONFIRMAR"
                    />
                    <br />
                    {
                        validCode &&
                        <span style={{ color: "red", fontSize: "0.8rem" }}>
                            El código ingresado no es correcto.
                        </span>
                    }
                </Col>
            }

            <ModalFooter>
               {
    !isDelete &&
    <Button
        size="sm"
        outline
        color="primary"
        onClick={(e) => {

            if (button === "Actualizar") {
                confirmationUpdate();
            } else {
                methodAction(e);
            }

        }}
    >
        {button}
    </Button>
    }
                    {
                        isDelete && <Button
        size="sm"
        outline
        color="primary"
        onClick={(e) => methodAction(e)}
    >
        {button}
</Button>
                }

                <Button size="sm" outline color='danger' type="button" onClick={toggle}>{ModalButtonCancel}</Button>
            </ModalFooter>
        </>
    )
}
